import { render, staticRenderFns } from "./MenuWrapperSmall.vue?vue&type=template&id=7af553e6&scoped=true&"
import script from "./MenuWrapperSmall.vue?vue&type=script&lang=js&"
export * from "./MenuWrapperSmall.vue?vue&type=script&lang=js&"
import style0 from "./MenuWrapperSmall.vue?vue&type=style&index=0&id=7af553e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af553e6",
  null
  
)

export default component.exports